(function () {
  var cache = {};
  var inFlight = {};

  window.kikaSnize = window.kikaSnize || {};

  function extractHandle(card) {
    var link = card.querySelector('a.snize-view-link') || card.querySelector('a[href*="/products/"]');
    if (!link && card.matches && card.matches('a[href*="/products/"]')) link = card;
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function getVariantId(card) {
    if (card.dataset.kikaSelectedVariant) return card.dataset.kikaSelectedVariant;
    var link = card.querySelector('a.snize-view-link');
    if (!link && card.matches && card.matches('a[href]')) link = card;
    if (!link) return null;
    var m = link.getAttribute('href').match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function injectBadge(card, doc) {
    // Remove existing
    var prev = card.querySelector('.ksd-injected-badge');
    if (prev) prev.parentNode.removeChild(prev);

    var badgeWrap = doc.querySelector('[data-ksd="badge"]');
    if (!badgeWrap) return;

    var overlay = badgeWrap.querySelector('.product-card__overlay');
    if (!overlay) return;

    var wrapper = card.querySelector('.snize-thumbnail-wrapper') || card.querySelector('.snize-thumbnail');
    if (!wrapper) return;
    wrapper.style.position = 'relative';

    var container = document.createElement('div');
    container.className = 'ksd-injected-badge';
    container.style.cssText = 'position:absolute;top:0;left:0;z-index:3;pointer-events:none;width:100%;flex:1;';
    container.appendChild(overlay.cloneNode(true));
    wrapper.appendChild(container);
  }

  function injectPrice(card, doc) {
    var priceWrap = doc.querySelector('[data-ksd="price"]');
    if (!priceWrap) return;

    var section = document.createElement('div');
    section.className = 'ksd-price-section';
    section.innerHTML = priceWrap.innerHTML;

    var existing = card.querySelector('.ksd-price-section');
    if (existing) {
      // Refresh — replace in place so position in DOM is preserved
      existing.parentNode.replaceChild(section, existing);
    } else {
      // First load — replace Searchanise's native price list
      var snizePrice = card.querySelector('.snize-price-list');
      if (!snizePrice) return;
      snizePrice.parentNode.replaceChild(section, snizePrice);
    }
  }

  // IO-5355: the collection card carries a judge.me rating row under the title;
  // Searchanise renders its own .snize-reviews from a separate index whose numbers
  // disagree, so that block stays hidden in CSS and the theme's row is injected here.
  // The card body is a flex column ordered entirely by `order` in
  // component-snize-cards.css, so appending is enough to land it under the title.
  function injectReviews(card, doc) {
    var row = doc.querySelector('[data-ksd="reviews"] .product-card__reviews');
    var existing = card.querySelector('.product-card__reviews');

    if (!row) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }

    var clone = row.cloneNode(true);
    if (existing) {
      existing.parentNode.replaceChild(clone, existing);
      return;
    }

    var body = card.querySelector('.snize-overhidden');
    if (!body) return;
    body.appendChild(clone);
  }

  function fetchAndInject(card, handle, variantId) {
    var cacheKey = handle + (variantId ? '__' + variantId : '');

    if (cache[cacheKey] !== undefined) {
      var doc = cache[cacheKey];
      if (doc) { injectBadge(card, doc); injectPrice(card, doc); injectReviews(card, doc); }
      return;
    }

    var waiters = inFlight[cacheKey];
    if (waiters) { waiters.push(card); return; }
    inFlight[cacheKey] = [card];

    var url = '/products/' + encodeURIComponent(handle) + '?sections=kika-discount-badge';
    if (variantId) url += '&variant=' + encodeURIComponent(variantId);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (data) {
        var html = (data['kika-discount-badge'] || '').trim();
        var doc = html ? new DOMParser().parseFromString(html, 'text/html') : null;
        cache[cacheKey] = doc;
        (inFlight[cacheKey] || []).forEach(function (c) {
          if (doc) { injectBadge(c, doc); injectPrice(c, doc); injectReviews(c, doc); }
        });
        delete inFlight[cacheKey];
      })
      .catch(function () {
        cache[cacheKey] = null;
        delete inFlight[cacheKey];
      });
  }

  function processCard(card) {
    if (card.dataset.kikaBadge) return;
    card.dataset.kikaBadge = '1';

    var handle = extractHandle(card);
    if (!handle) return;
    fetchAndInject(card, handle, getVariantId(card));
  }

  // Called by snize-variants.js when a variant pill is clicked
  window.kikaSnize.refreshCard = function (card, variantId) {
    var handle = extractHandle(card);
    if (!handle) return;
    // Bust cache for this variant so we always get fresh data
    var cacheKey = handle + '__' + variantId;
    delete cache[cacheKey];
    fetchAndInject(card, handle, variantId);
  };

  // IO-4944: Searchanise renders the pagination prev/next labels client-side
  // from its own dashboard config, which has no `lv` UI locale -- so kika.lv
  // served the Lithuanian "Ankstesnis"/"Kitas" on an lv-LV page. Its widget
  // markup is already post-processed here (see the MutationObserver below), so
  // relabel the two buttons from the theme locale files instead. Only the inner
  // text span is written; the arrow is a CSS background-image on the parent
  // (see base-new.css) and is deliberately left alone.
  var PAGER_LABELS = [
    ['.snize-pagination-prev', 'paginationPrevious'],
    ['.snize-pagination-next', 'paginationNext']
  ];

  function localizePagination() {
    var strings = window.searchaniseStrings;
    if (!strings) return;
    PAGER_LABELS.forEach(function (pair) {
      var label = strings[pair[1]];
      if (!label) return;
      document.querySelectorAll(pair[0] + ' .snize-pagination-text').forEach(function (el) {
        // Only write when it actually differs, so the write we trigger in the
        // observer below settles on the second pass instead of looping.
        if (el.textContent !== label) el.textContent = label;
      });
    });
  }

  // IO-4944: Searchanise points the "next" button href at the LAST page
  // instead of the next one (on page 1 of 52 it links straight to page=52),
  // on every locale. Its own click handler computes the right target, so an
  // ordinary click still works and only the href is wrong -- but that breaks
  // middle-click, ctrl+click, "open link in new tab", copy-link, and anything
  // crawling the markup. The prev button href is correct and is left alone.
  function pageOfHref(el) {
    var href = el.getAttribute('href');
    var m = href && href.match(/[?&]page=(\d+)/);
    return m ? Number(m[1]) : null;
  }

  function fixNextPageHref() {
    var next = document.querySelector('a.snize-pagination-next[href]');
    if (!next) return;

    // The numbered page links are the only trustworthy source of a real URL:
    // they carry q, tab and any active filters that must survive the rewrite.
    var numbered = [];
    document.querySelectorAll('.snize-pagination a[href]').forEach(function (a) {
      if (/snize-pagination-(prev|next)/.test(a.className)) return;
      if (pageOfHref(a) !== null) numbered.push(a);
    });
    if (!numbered.length) return;

    // Read the current page off the highlighted item rather than its href, so
    // this still works if Searchanise renders the active page as a span.
    var active = document.querySelector('.snize-pagination .active');
    var current = active ? parseInt(active.textContent.trim(), 10) : NaN;
    if (!current) return;
    var target = current + 1;

    var lastPage = numbered.reduce(function (max, a) {
      var p = pageOfHref(a);
      return p > max ? p : max;
    }, 0);
    if (target > lastPage) return;

    var href = null;
    for (var i = 0; i < numbered.length; i++) {
      if (pageOfHref(numbered[i]) === target) { href = numbered[i].getAttribute('href'); break; }
    }
    // Target outside the shown page window: derive it from a sibling link so
    // every other query parameter is preserved verbatim.
    if (!href) href = numbered[0].getAttribute('href').replace(/([?&]page=)\d+/, '$1' + target);

    if (next.getAttribute('href') !== href) next.setAttribute('href', href);
  }

  // IO-5355: the collection page puts a label in front of its sort select
  // (products.facets.sort_by_label, rendered by snippets/facets.liquid); Searchanise
  // ships the bare dropdown. Insert the same label so both sort bars read alike.
  // Searchanise re-renders this panel on every filter and sort change, so this also
  // runs from the observer below; the existence check keeps it idempotent, so the
  // mutation our own insert triggers settles instead of looping.
  function insertSortLabel() {
    var strings = window.searchaniseStrings;
    var text = strings && strings.sortByLabel;
    if (!text) return;

    document.querySelectorAll('.snize-horizontal-right').forEach(function (panel) {
      if (panel.querySelector(':scope > .snize-kika-sort-label')) return;
      var dropdown = panel.querySelector(':scope > .snize-main-panel-dropdown');
      if (!dropdown) return;

      var label = document.createElement('span');
      label.className = 'snize-kika-sort-label';
      label.textContent = text;
      panel.insertBefore(label, dropdown);
    });
  }

  var CARD_SELECTOR = 'li.snize-product, a.snize-item';

  function scanCards(root) {
    (root || document).querySelectorAll(CARD_SELECTOR).forEach(function (card) {
      if (!card.dataset.kikaBadge) processCard(card);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(CARD_SELECTOR)) {
          processCard(node);
        } else {
          scanCards(node);
        }
      });
    });
    localizePagination();
    fixNextPageHref();
    insertSortLabel();
  });

  function init() {
    scanCards(document);
    localizePagination();
    fixNextPageHref();
    insertSortLabel();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
